import * as React from 'react';

import { use$ } from '@legendapp/state/react';
import { Breakpoints } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

import { OptionSelector } from '../option-selector/option-selection-wrapper';

import { desktopGridArea, fullscreenGridArea, minimizedGridArea, mobileGridArea } from './utils/grid-areas';

import { deviceSettingStore, disclaimerStore, fullscreenStore, interiorStore, zoomStore } from '../../store';
import { ActionWrapperBackgroundMixin } from '../action-wrapper-background.mixin';
import { FullscreenButton } from '../fullscreen/fullscreen-button';
import Header from '../header/header';
import { MinimizeButton } from '../zoom-controls/minimize-control-button';

export default function BottomControlPanel() {
	const disclaimerId = use$(disclaimerStore.disclaimerId);
	const isZoomed = use$(zoomStore.isZoomed);
	const isTopHeaderVisible = use$(fullscreenStore.isTopHeaderVisible);
	const isFullscreenMode = use$(fullscreenStore.isFullscreenMode);
	const isFullscreenAvailableOnDevice = use$(fullscreenStore.isFullscreenAvailableOnDevice);
	const isHidden = use$(interiorStore.isHidden);
	const isMobileDevice = use$(deviceSettingStore.isMobileDevice);
	const fullscreenButtonCondition = isFullscreenAvailableOnDevice && isMobileDevice && !isTopHeaderVisible;

	return (
		<BottomControlPanelContainer $isMinimized={isZoomed} $isFullscreen={isFullscreenMode} $isHidden={isHidden}>
			{!isTopHeaderVisible ? <Header /> : <div id={disclaimerId} />}
			{isZoomed ? <MinimizeButton /> : <>{fullscreenButtonCondition && <FullscreenButton />}</>}
			{!isZoomed && <OptionSelector />}
		</BottomControlPanelContainer>
	);
}

const BottomControlPanelContainer = styled.div<{
	$isMinimized?: boolean;
	$isFullscreen?: boolean;
	$isHidden?: boolean;
}>`
	// Why not grid? because height is dynamic
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;

	display: grid;
	grid-template-columns: repeat(8, 1fr);
	grid-template-rows: auto;

	max-height: ${({ $isMinimized }) => ($isMinimized ? '72px' : '500px')};
	opacity: ${({ $isHidden }) => ($isHidden ? '0' : '1')};
	transition:
		max-height 0.3s ease,
		opacity 0.3s ease;

	padding-top: ${({ theme }) => theme.size.static300};
	padding-bottom: ${({ theme }) => theme.size.static300};

	border-top-left-radius: ${({ theme }) => (theme.variant === 'v26' ? theme.size.static300 : theme.size.static150)};
	border-top-right-radius: ${({ theme }) => (theme.variant === 'v26' ? theme.size.static300 : theme.size.static150)};

	${mobileGridArea}
	${({ $isFullscreen }) => $isFullscreen && fullscreenGridArea} ${({ $isMinimized }) =>
		$isMinimized && minimizedGridArea} @media (
    min-width: ${Breakpoints.b960}px) {
		${desktopGridArea}
		${({ $isFullscreen }) => $isFullscreen && fullscreenGridArea}
    ${({ $isMinimized }) => $isMinimized && minimizedGridArea}
	}
	${ActionWrapperBackgroundMixin()}
`;
